/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type DepartmentFunction = typeof DepartmentFunction[keyof typeof DepartmentFunction];


export const DepartmentFunction = {
  HeadOfDepartment: 'HeadOfDepartment',
  HeadOfWorkarea: 'HeadOfWorkarea',
  CanApproveAbsenceRequests: 'CanApproveAbsenceRequests',
} as const;
